module.exports = ".content {\n  -webkit-transition: -webkit-filter 0.3s;\n  transition: -webkit-filter 0.3s;\n  transition: filter 0.3s;\n  transition: filter 0.3s, -webkit-filter 0.3s;\n  padding-top: 80px;\n  position: relative;\n}\n\n.page-actions {\n  padding: 0px;\n  width: 100%;\n  background-color: #f7f7f7;\n}\n\n#dasboard {\n  width: 100%;\n}\n\n/*# sourceMappingURL=dashboard.css.map */"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard/css/dashboard.css
// module id = ./src/app/components/dashboard/dashboard/css/dashboard.css
// module chunks = main